// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface QuickOrderProduct {
    isAddingToCart?: boolean;
}

export type xQuickOrderStateType = Readonly<{
    isAddingToCart?: boolean;
}>;

export const initialQuickOrderState: xQuickOrderStateType = {
    isAddingToCart: false,
};

const reducer = {
    "xQuickOrder/update": (draft: Draft<xQuickOrderStateType>, action: { isAddingToCart: boolean }) => {
        draft.isAddingToCart = action.isAddingToCart;
    },
};

const xQuickOrder = createTypedReducerWithImmer(initialQuickOrderState, reducer);

(reducers as any).xQuickOrder = xQuickOrder;

export type xQuickOrderState = {
    xQuickOrder: xQuickOrderStateType;
} & ApplicationState;

type xQuickOrderReducers = {
    [key: string]: typeof xQuickOrder;
};

export type xQuickOrderActions = Parameters<xQuickOrderReducers[keyof xQuickOrderReducers]>[1];
